import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2ffded7e&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=2ffded7e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffded7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ffded7e')) {
      api.createRecord('2ffded7e', component.options)
    } else {
      api.reload('2ffded7e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2ffded7e&scoped=true", function () {
      api.rerender('2ffded7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/notifications/index.vue"
export default component.exports